import { render, staticRenderFns } from "./ProductsAdd.vue?vue&type=template&id=7b7d1e5c&scoped=true&"
import script from "./ProductsAdd.vue?vue&type=script&lang=js&"
export * from "./ProductsAdd.vue?vue&type=script&lang=js&"
import style0 from "./ProductsAdd.vue?vue&type=style&index=0&id=7b7d1e5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7d1e5c",
  null
  
)

export default component.exports